import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Divider,
  MenuItem,
  Pagination,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import Header from "../../components/Header";
import { Add, CheckCircle, Download, Upload } from "@mui/icons-material";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import apiService from "../../service/apiService";
import "../../assets/styles/cropmanage.css";
import * as XLSX from "xlsx";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


const Target = () => {
  const [targets, setTargets] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [years, setYears] = useState([]);
  const [targetNames] = useState([
    "CB Meeting",
    "Total Area Of Seed Production (in ha)",
    "Cluster Training",
    "Exposure / Learning Event",
    "Awareness Meeting",
    "Farmer Field Days",
  ]);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTarget, setSelectedTarget] = useState(null);
  const [formData, setFormData] = useState({
    targetName: "",
    targetId: "",
    districtName: "",
    districtId: "",
    yearValue: "",
    yearId: "",
    targetValue: "",
  });

  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  const [searchTarget, setSearchTarget] = useState("");
  const [searchDistrict, setSearchDistrict] = useState("");
  const [searchYear, setSearchYear] = useState("");

  // New states for Target & Achievement functionality
  const [openTargetAchievementDialog, setOpenTargetAchievementDialog] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  // Rich text editor states
  const [openRichTextDialog, setOpenRichTextDialog] = useState(false);
  const [richTextContent, setRichTextContent] = useState("");
  const [richTextType, setRichTextType] = useState("");
  const [richTextLoading, setRichTextLoading] = useState(false);
  const [fetchingRichText, setFetchingRichText] = useState(false);


  // Categories for dropdown
  const categories = [
    "climate-smart-crop-intensification",
    "capacity-building",
    "capacity-building-subtype",
    "farmer-field-day",
    "ffd-sub-type",
    "district-wise-achievement",
    "varieties",
    "program-coverage-map",
    "sensitization-meeting",
    // "seed-data",
    // "grain-data",
    "achievements",
    "impact",
  ];


  const categoryConfig = {
  "climate-smart-crop-intensification": {
    api: "climate-smart-crop-intensification",
    headers: ["croptype", "dist", "year", "target", "achievement"],
    example: ["BS-FS", "Keonjhar", "2027", "5400", "2767.29"],
    dummyRows: [
      ["BS-FS", "Keonjhar", 2027, "", ""],
      ["FS-CS", "Keonjhar", 2027, "", ""],
      ["CS UPSCALING", "Keonjhar", 2027, "", ""],
      ["TL OUTREACH", "Keonjhar", 2027, "", ""],
      ["BS-FS", "Kalahandi", 2027, "", ""],
      ["FS-CS", "Kalahandi", 2027, "", ""],
      ["CS UPSCALING", "Kalahandi", 2027, "", ""],
      ["TL OUTREACH", "Kalahandi", 2027, "", ""],
      ["BS-FS", "Bargarh", 2027, "", ""],
      ["FS-CS", "Bargarh", 2027, "", ""],
      ["CS UPSCALING", "Bargarh", 2027, "", ""],
      ["TL OUTREACH", "Bargarh", 2027, "", ""],
    ],
  },

  "capacity-building": {
    api: "capacity-building",
    headers: ["year", "dist", "cbtype", "target", "achievement", "male", "female"],
    example: ["2027", "Keonjhar", "Awareness Meeting", "200", "150", "80", "70"],
    dummyRows: [
      [2027, "Keonjhar", "Awareness Meeting", "", "", "", ""],
      [2027, "Keonjhar", "Cluster Training", "", "", "", ""],
      [2027, "Keonjhar", "Exposure Visit", "", "", "", ""],
      [2027, "Kalahandi", "Awareness Meeting", "", "", "", ""],
      [2027, "Kalahandi", "Cluster Training", "", "", "", ""],
      [2027, "Kalahandi", "Exposure Visit", "", "", "", ""],
      [2027, "Bargarh", "Awareness Meeting", "", "", "", ""],
      [2027, "Bargarh", "Cluster Training", "", "", "", ""],
      [2027, "Bargarh", "Exposure Visit", "", "", "", ""],
    ]
  },

   "capacity-building-subtype": {
    api: "cb-sub-type",
    headers: ["year", "dist", "cbtype", "subtype", "subtypevalue"],
    example: ["2027", "Keonjhar", "Awareness Meeting", "Sensitizing Meeting", "150"],
    dummyRows: [
      [2027, "Keonjhar", "Awareness Meeting", "Sensitizing Meeting", ""],
      [2027, "Keonjhar", "Awareness Meeting", "Planning Meeting", ""],
      [2027, "Keonjhar", "Awareness Meeting", "Others", ""],
      [2027, "Keonjhar", "Cluster Training", "Seed Production", ""],
      [2027, "Keonjhar", "Cluster Training", "Value Addition & Market Linkage", ""],
      [2027, "Keonjhar", "Cluster Training", "Institutional", ""],
      [2027, "Keonjhar", "Exposure Visit", "Farmer", ""],
      [2027, "Keonjhar", "Exposure Visit", "Govt. Official", ""],
      [2027, "Keonjhar", "Exposure Visit", "Others", ""],
      [2027, "Kalahandi", "Awareness Meeting", "Sensitizing Meeting", ""],
      [2027, "Kalahandi", "Awareness Meeting", "Planning Meeting", ""],
      [2027, "Kalahandi", "Awareness Meeting", "Others", ""],
      [2027, "Kalahandi", "Cluster Training", "Seed Production", ""],
      [2027, "Kalahandi", "Cluster Training", "Value Addition & Market Linkage", ""],
      [2027, "Kalahandi", "Cluster Training", "Institutional", ""],
      [2027, "Kalahandi", "Exposure Visit", "Farmer", ""],
      [2027, "Kalahandi", "Exposure Visit", "Govt. Official", ""],
      [2027, "Kalahandi", "Exposure Visit", "Others", ""],
      [2027, "Bargarh", "Awareness Meeting", "Sensitizing Meeting", ""],
      [2027, "Bargarh", "Awareness Meeting", "Planning Meeting", ""],
      [2027, "Bargarh", "Awareness Meeting", "Others", ""],
      [2027, "Bargarh", "Cluster Training", "Seed Production", ""],
      [2027, "Bargarh", "Cluster Training", "Value Addition & Market Linkage", ""],
      [2027, "Bargarh", "Cluster Training", "Institutional", ""],
      [2027, "Bargarh", "Exposure Visit", "Farmer", ""],
      [2027, "Bargarh", "Exposure Visit", "Govt. Official", ""],
      [2027, "Bargarh", "Exposure Visit", "Others", ""],
    ]
  },

  "farmer-field-day": {
    api: "widgets",
    headers: ["Activity", "Year", "District", "Target", "Acheivement", "Male", "Female"],
    example: ["Farmer Field Day", "2027", "Keonjhar", "3", "2", "302", "197"],
    dummyRows: [
      ["Farmer Field Day", 2027, "Keonjhar", "", "", "", ""],
      ["Farmer Field Day", 2027, "Kalahandi", "", "", "", ""],
      ["Farmer Field Day", 2027, "Bargarh", "", "", "", ""],
    ]
  },

  "ffd-sub-type": {
    api: "cb-sub-type",
    headers: ["year", "dist", "cbtype", "subtype", "subtypevalue"],
    example: [2027, "Keonjhar", "Farmer Field Days", "Farmers", "140"],
    dummyRows: [
      [2027, "Keonjhar", "Farmer Field Days", "Farmer", ""],
      [2027, "Keonjhar", "Farmer Field Days", "Govt. Official", ""],
      [2027, "Keonjhar", "Farmer Field Days", "Others", ""],
      [2027, "Kalahandi", "Farmer Field Days", "Farmer", ""],
      [2027, "Kalahandi", "Farmer Field Days", "Govt. Official", ""],
      [2027, "Kalahandi", "Farmer Field Days", "Others", ""],
      [2027, "Bargarh", "Farmer Field Days", "Farmer", ""],
      [2027, "Bargarh", "Farmer Field Days", "Govt. Official", ""],
      [2027, "Bargarh", "Farmer Field Days", "Others", ""],
    ]
  },

  "district-wise-achievement": {
    api: "distwise-achievement",
    headers: ["year", "district", "areaofcoverage"],
    example: ["2027", "Keonjhar", "20"],
    dummyRows: [
      [2027, "Keonjhar", ""],
      [2027, "Bargarh", ""],
      [2027, "Kalahandi", ""],
    ]
  },

  "varieties": {
    api: "crop-variety",
    headers: ["year", "crop", "variety"],
    example: ["2027", "Greengram", "Sikha, Virat"],
    dummyRows: [
      [2027,"Greengram",""],
      [2027,"Blackgram",""],
      [2027,"Chickpea",""],
      [2027,"Lentil",""],
      [2027,"Fieldpea",""],
      [2027,"Sesamum",""],
      [2027,"Mustard",""],
    ]
  },

  "program-coverage-map": {
    api: "map-program",
    headers: ["year", "dist", "data", "value"],
    example: ["2027", "Keonjhar", "totalPg", "50"],
    dummyRows: [
      [2027,"Keonjhar","totalPg",""],
      [2027,"Keonjhar","totalPgMembers",""],
      [2027,"Keonjhar","totalPaniPanchayat",""],
      [2027,"Bargarh","totalPg",""],
      [2027,"Bargarh","totalPgMembers",""],
      [2027,"Bargarh","totalPaniPanchayat",""],
      [2027,"Kalahandi","totalPg",""],
      [2027,"Kalahandi","totalPgMembers",""],
      [2027,"Kalahandi","totalPaniPanchayat",""],
    ]
  },

  "sensitization-meeting": {
    api: "sensitization-meeting",
    headers: ["year", "dist", "mip", "participant", "male", "female"],
    example: ["2027", "Keonjhar", "12", "120", "60", "60"],
    dummyRows: [
      [2027,"Keonjhar","","","",""],
      [2027,"Kalahandi","","","",""],
      [2027,"Bargarh","","","",""],
    ]
  },

  "seed-data": {
    api: "seed-data",
    headers: [
      "District",
      "FPC",
      "Year", 
      "Crop",
      "Season",
      "Variety",
      "Class",
      "Producer Group (no.)",
      "Farmer (no.)",
      "Surplus Quantity (q.)",
      "MSP (₹)",
      "Value @MSP (₹)",
      "Sale Price per q. (₹)",
      "Total Sale (₹)",
      "Incremental value per qtl. (₹)",
      "Total incremental value (₹)",
      "Linkage to OSSC (in q.)",
      "Linkage to Others agency (in q.)"
    ],
    example: [
      "Kalahandi",
      "KPFPCL",
      "2027", 
      "Greengram",
      "Rabi",
      "Virat",
      "BS-FS",
      "4",
      "25",
      "50",
      "8682",
      "434100",
      "9200",
      "460000",
      "518",
      "25900",
      "35",
      "5"
    ],
    dummyRows: [
      ["Kalahandi","KPFPCL",2027,"Greengram","Rabi","Virat","BS-FS",4,25,50,8682,"434100",9200,"460000",518,"25900",35,5],
      ["Keonjhar","KPFPCL",2027,"Blackgram","Rabi","VBN-11","FS-CS","","","","","","","","",""],
      ["Bargarh","KPFPCL",2027,"Chickpes","Rabi","NBeG-47","FS-CS","","","","","","","","",""],
    ]
  },

  "grain-data": {
    api: "grain-data",
    headers: [
      "District",
      "Year",
      "Crop",
      "Season",
      "Producer Group (no.)",
      "Farmer (no.)",
      "Surplus Quantity (q.)",
      "MSP (₹)",
      "Value @MSP (₹)",
      "Sale Price per q. (₹)",
      "Total Sale (₹)",
      "Incremental value per qtl. (₹)",
      "Total incremental value (₹)"
    ],
    example: [
      "Kalahandi",
      "2027",
      "Greengram",
      "Rabi",
      "5",
      "25",
      "80",
      "8682",
      "694560",
      "9000",
      "720000",
      "318",
      "25440"
    ],
    dummyRows: [
      ["Kalahandi",2027,"Greengram","Rabi",5,25,80,8682,"694560",9000,"720000",318,"25440"],
      ["Keonjhar",2027,"Blackgram","Rabi","","","","","","","","",""],
      ["Bargarh",2027,"Chickpes","Rabi","","","","","","","","",""],
      ["Kalahandi",2027,"Redgram","Kharif","","","","","","","","",""],
    ]
  }
};

const handleCategoryChange = (value) => {
  console.log("Category changed to:", value);
  setSelectedCategory(value);
  if (value === "achievements" || value === "impact") {
    setOpenTargetAchievementDialog(false);
    handleOpenRichText(value);
  }
};

const handleOpenRichText = async (type) => {
  setRichTextType(type);
  setRichTextContent("");
  setOpenRichTextDialog(true);
  console.log("entering into fetching data and")
  try {
    setFetchingRichText(true);
    console.log("entered in try block")
    // Determine which API to call based on type
    const apiUrl = type === "achievements" 
      ? "/temp-upload/dashboard/seeddata?year=&district="
      : "/temp-upload/dashboard/graindata?year=&district=";
    
    // Add query parameters if needed (year and district)
    const response = await apiService.post(apiUrl);
    console.log("response is", response.data);
    if (response.data?.data) {
      setRichTextContent(response.data.data);
    }
  } catch (error) {
    console.error("Error fetching rich text data:", error);
    alert("Failed to load data!");
  } finally {
    setFetchingRichText(false);
  }
};

const handleSaveRichText = async () => {
  if (!richTextContent.trim()) {
    alert("Please write something!");
    return;
  }
  try {
    setRichTextLoading(true);
    
    // Use different API endpoints for achievements and impact
    const apiEndpoint = richTextType === "achievements" 
      ? "/temp-upload/seed-data" 
      : "/temp-upload/grain-data";
    
    await apiService.post(apiEndpoint, {
      description: richTextContent,
    });
    
    alert(`${richTextType} saved successfully!`);
    setOpenRichTextDialog(false);
    setRichTextContent("");
  } catch (error) {
    console.error("Error saving rich text:", error);
    alert("Failed to save!");
  } finally {
    setRichTextLoading(false);
  }
};



  // ✅ Fetch All Targets (with pagination + search)
  const fetchTargets = async () => {
    try {
      const payload = {
        pageNumber: page,
        pageSize: pageSize,
        targetName: searchTarget || "",
        districtName: searchDistrict || "",
        year: searchYear || "",
      };

      const response = await apiService.post("/targets/get-all", payload);

      if (response.data?.body?.data) {
        setTargets(response.data.body.data);
        setTotalItems(response.data.body.recordsCount || 0);
        setTotalPage(response.data.body.pageCount || 0);
      } else {
        setTargets([]);
        setTotalItems(0);
        setTotalPage(0);
      }
    } catch (error) {
      console.error("Error fetching targets:", error);
    }
  };

  // ✅ Fetch Districts
  const fetchDistricts = async () => {
    try {
      const res = await apiService.get("/districts/get-all");
      if (res.data) setDistricts(res.data);
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  // ✅ Fetch Years
  const fetchYears = async () => {
    try {
      const res = await apiService.get("/years/get-all");
      if (res.data) setYears(res.data);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };

  useEffect(() => {
    fetchTargets();
  }, [page, searchTarget, searchDistrict, searchYear]);

  useEffect(() => {
    fetchDistricts();
    fetchYears();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Auto map IDs for dropdowns
    if (name === "districtId") {
      const selected = districts.find((d) => d.districtId === value);
      setFormData({
        ...formData,
        districtId: value,
        districtName: selected?.districtName || "",
      });
    } else if (name === "yearId") {
      const selected = years.find((y) => y.yearId === value);
      setFormData({
        ...formData,
        yearId: value,
        yearValue: selected?.yearValue || "",
      });
    } else if (name === "targetName") {
      setFormData({ ...formData, targetName: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleAddClick = () => {
    setFormData({
      targetName: "",
      targetId: "",
      districtName: "",
      districtId: "",
      yearValue: "",
      yearId: "",
      targetValue: "",
    });
    setSelectedTarget(null);
    setOpenDialog(true);
  };

  // Handle Add Target & Achievement button click
  const handleAddTargetAchievement = () => {
    setOpenTargetAchievementDialog(true);
    setSelectedCategory("");
    setUploadFile(null);
  };

  const handleEditClick = (target) => {
    setFormData({
      targetName: target.targetName,
      targetId: target.targetId,
      districtName: target.districtName,
      districtId: target.districtId,
      yearValue: target.yearValue,
      yearId: target.yearId,
      targetValue: target.targetValue,
    });
    setSelectedTarget(target);
    setOpenDialog(true);
  };

  const handleSubmit = async () => {
    try {
      if (!formData.targetName || !formData.districtId || !formData.yearId) {
        alert("Please fill all required fields!");
        return;
      }

      if (selectedTarget) {
        if (!window.confirm("Are you sure you want to update this target?"))
          return;

        await apiService.put(`/targets/${selectedTarget.id}`, {
          targetName: formData.targetName,
          targetId: formData.targetId || selectedTarget.targetId,
          yearId: formData.yearId,
          districtId: formData.districtId,
          targetValue: formData.targetValue,
        });
      } else {
        if (!window.confirm("Are you sure you want to add this target?")) return;

        await apiService.post("/targets", {
          targetName: formData.targetName,
          targetId: formData.targetId || null,
          yearId: formData.yearId,
          districtId: formData.districtId,
          targetValue: formData.targetValue,
        });
      }

      setOpenDialog(false);
      fetchTargets();
    } catch (error) {
      console.error("Error saving target:", error);
    }
  };

  const handleDeleteClick = async (id) => {
    if (!window.confirm("Are you sure you want to delete this target?")) return;
    try {
      await apiService.delete(`/targets/${id}`);
      fetchTargets();
    } catch (error) {
      console.error("Error deleting target:", error);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleDownloadFormat = () => {
    if (!selectedCategory) {
      alert("Please select category first!");
      return;
    }

    const config = categoryConfig[selectedCategory];
    if (!config) {
      alert("Invalid category config!");
      return;
    }

    const rows = [
      config.headers,
      ...(config.dummyRows || [])
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(rows);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Format");

    // File name
    const fileName = `${selectedCategory}-format.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  // Handle file upload
  const handleFileUpload = async () => {
    if (!selectedCategory) {
      alert("Please select a category first!");
      return;
    }

    if (!uploadFile) {
      alert("Please select a file first!");
      return;
    }

    const config = categoryConfig[selectedCategory];
    if (!config) {
      alert("Invalid upload config!");
      return;
    }

    try {
      setUploadLoading(true);

      const formData = new FormData();
      formData.append("file", uploadFile);

      const response = await apiService.post(
        `/temp-upload/${config.api}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      alert("Uploaded successfully!");
      setUploadFile(null);
      setOpenTargetAchievementDialog(false);

    } catch (error) {
      console.error("Upload error:", error);
      alert("Upload failed!");
    } finally {
      setUploadLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!/\.(xlsx|xls|csv)$/i.test(file.name)) {
      alert("Upload only Excel (.xlsx/.xls) or CSV.");
      return;
    }

    setUploadFile(file);
  };

  const displayNameMap = {
    "climate-smart-crop-intensification": "Crop Intensification",
    "sensitization-meeting": "Beneficial Coverage",
    "capacity-building-subtype":"Capacity Building Subtype Coverage",
    "farmer-field-day":"Farmer Field Day",
    "ffd-sub-type":"Farmer Field Day Subtype",
    "district-wise-achievement":"District Wise Achievement",
    "varieties":"Varieties",
    "program-coverage-map":"Geographical Presence",
    // "seed-data": "Seed market linkage by PGs",
    // "grain-data": "Grain market linkage by PGs",
    achievements: "Achievements",
    impact: "Impact",
  };

  const getDisplayName = (category) => {
    return displayNameMap[category.toLowerCase()] 
      || category.split("-").map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(" ");
  };


  return (
    <Box className="target-page" sx={{ p: 3 }}>
      <Header title="Targets" subtitle="Manage all performance targets" />
      <Divider sx={{ my: 2 }} />

      {/* Add Buttons */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={handleAddTargetAchievement}
        >
          Add Target & Achievement
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={handleAddClick}
        >
          Add Target
        </Button>
      </Box>

      {/* Table Section */}
      <Box sx={{ overflowX: "auto" }}>
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Target Name</th>
              <th>District Name</th>
              <th>Year</th>
              <th>Target Value</th>
              <th>Actions</th>
            </tr>

            {/* 🔍 Search Row */}
            <tr>
              <th>
                <input
                  type="text"
                  placeholder="Search Target"
                  className="form-control form-control-sm"
                  value={searchTarget}
                  onChange={(e) => {
                    setSearchTarget(e.target.value);
                    setPage(1);
                  }}
                />
              </th>
              <th>
                <input
                  type="text"
                  placeholder="Search District"
                  className="form-control form-control-sm"
                  value={searchDistrict}
                  onChange={(e) => {
                    setSearchDistrict(e.target.value);
                    setPage(1);
                  }}
                />
              </th>
              <th>
                <input
                  type="text"
                  placeholder="Search Year"
                  className="form-control form-control-sm"
                  value={searchYear}
                  onChange={(e) => {
                    setSearchYear(e.target.value);
                    setPage(1);
                  }}
                />
              </th>
              <th colSpan={2}></th>
            </tr>
          </thead>

          <tbody>
            {targets.length > 0 ? (
              targets.map((target) => (
                <tr key={target.id}>
                  <td>{target.targetName}</td>
                  <td>{target.districtName}</td>
                  <td>{target.yearValue}</td>
                  <td>{target.targetValue}</td>
                  <td
                    className="p-0"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "6px",
                    }}
                  >
                    {/* ✏️ Edit */}
                    <button
                      className="btn btn-md"
                      onClick={() => handleEditClick(target)}
                      title="Edit"
                      style={{
                        padding: "4px 6px",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <FaRegEdit color="#0b0f13" size={18} />
                    </button>

                    {/* 🗑️ Delete */}
                    <button
                      className="btn btn-md"
                      onClick={() => handleDeleteClick(target.id)}
                      title="Delete"
                      style={{
                        padding: "4px 6px",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <FaTrash color="#110b0bff" size={18} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  No targets available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Box>

      {/* ✅ Pagination */}
      <div className="p-2 d-flex justify-content-center">
        <Pagination
          count={totalPage}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </div>

      {/* Add/Edit Target Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold" }}>
          {selectedTarget ? "Edit Target" : "Add Target"}
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {/* Target Name Dropdown */}
            <Grid item xs={12}>
              <TextField
                select
                label="Target Name"
                name="targetName"
                fullWidth
                variant="outlined"
                value={formData.targetName}
                onChange={handleChange}
              >
                {targetNames.map((name, index) => (
                  <MenuItem key={index} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* District Dropdown */}
            <Grid item xs={12}>
              <TextField
                select
                label="District Name"
                name="districtId"
                fullWidth
                variant="outlined"
                value={formData.districtId}
                onChange={handleChange}
              >
                {districts.map((district) => (
                  <MenuItem
                    key={district.districtId}
                    value={district.districtId}
                  >
                    {district.districtName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* Year Dropdown */}
            <Grid item xs={12}>
              <TextField
                select
                label="Year"
                name="yearId"
                fullWidth
                variant="outlined"
                value={formData.yearId}
                onChange={handleChange}
              >
                {years.map((year) => (
                  <MenuItem key={year.yearId} value={year.yearId}>
                    {year.yearValue}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* Target Value */}
            <Grid item xs={12}>
              <TextField
                label="Target Value"
                name="targetValue"
                fullWidth
                variant="outlined"
                value={formData.targetValue}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="success"
            startIcon={<CheckCircle />}
            onClick={handleSubmit}
          >
            {selectedTarget ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Target & Achievement Dialog */}
      <Dialog
        open={openTargetAchievementDialog}
        onClose={() => setOpenTargetAchievementDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold" }}>
          Add Target & Achievement
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            {/* Category Selection */}
            <Grid item xs={12}>
              <TextField
                select
                label="Select Category"
                fullWidth
                variant="outlined"
                value={selectedCategory}
                onChange={(e) => handleCategoryChange(e.target.value)}
              >
                {categories.map((category) => {
                  const specialCases = {
                    "climate-smart-crop-intensification": "Crop Intensification",
                    "sensitization-meeting": "Beneficial Coverage",
                    "capacity-building-subtype":"Capacity Building Subtype Coverage",
                    "farmer-field-day":"Farmer Field Day",
                    "ffd-sub-type":"Farmer Field Day Subtype",
                    "district-wise-achievement": "District Wise Achievement",
                    "varieties": "Varieties",
                    "program-coverage-map": "Geographical Presence",
                    // "seed-data": "Seed market linkage by PGs",
                    // "grain-data": "Grain market linkage by PGs",
                    "achievements": "Achievements",
                    "impact": "Impact",
                  };
                  
                  const displayName = specialCases[category.toLowerCase()] 
                    || category.split("-").map(word => 
                        word.charAt(0).toUpperCase() + word.slice(1)
                      ).join(" ");
                  
                  return (
                    <MenuItem key={category} value={category}>
                      {displayName}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>

            {/* Action Buttons */}
            {selectedCategory && selectedCategory !== "achievements" && selectedCategory !== "impact" && (
              <Grid item xs={12}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Actions for {getDisplayName(selectedCategory)}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                      <Button
                        variant="outlined"
                        startIcon={<Download />}
                        onClick={handleDownloadFormat}
                      >
                        Download Format
                      </Button>
                      
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<Upload />}
                      >
                        Select File
                        <input
                          type="file"
                          hidden
                          accept=".xlsx,.xls,.csv"
                          onChange={handleFileChange}
                        />
                      </Button>
                      
                      {uploadFile && (
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Selected file: {uploadFile.name}
                        </Typography>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            )}

            {/* Sample Format Preview */}
            {selectedCategory && selectedCategory !== "achievements" && selectedCategory !== "impact" && (
  <Grid item xs={12}>
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Expected Format
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          Your Excel/CSV file must contain the following columns:
        </Typography>

        {/* DYNAMIC HEADERS */}
        <Box sx={{ p: 1, backgroundColor: "#f5f5f5", borderRadius: 1 }}>
          <Typography variant="body2" fontFamily="monospace">
            {categoryConfig[selectedCategory].headers.join(", ")}
          </Typography>
        </Box>

        {/* Example Row */}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Example:
        </Typography>

        <Box sx={{ p: 1, backgroundColor: "#f5f5f5", borderRadius: 1 }}>
          <Typography variant="body2" fontFamily="monospace">
            {categoryConfig[selectedCategory].example.join(", ")}
          </Typography>
        </Box>

      </CardContent>
    </Card>
  </Grid>
)}

          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenTargetAchievementDialog(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            startIcon={<Upload />}
            onClick={handleFileUpload}
            disabled={!uploadFile || uploadLoading}
          >
            {uploadLoading ? "Uploading..." : "Upload Data"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Rich Text Editor Dialog */}
<Dialog
  open={openRichTextDialog}
  onClose={() => setOpenRichTextDialog(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle sx={{ fontWeight: "bold" }}>
    {richTextType === "achievements" ? "Add Achievements" : "Add Impact"}
  </DialogTitle>
  <DialogContent dividers>
    {fetchingRichText ? (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <Typography>Loading data...</Typography>
      </Box>
    ) : (
      <Box sx={{ minHeight: "300px" }}>
        <ReactQuill
          theme="snow"
          value={richTextContent}
          onChange={setRichTextContent}
          modules={{
            toolbar: [
              [{ header: [1, 2, 3, false] }],
              [{ font: ["arial", "times-new-roman", "courier", "verdana"] }],
              [{ size: ["small", false, "large", "huge"] }],
              ["bold", "italic", "underline"],
              [{ color: [] }, { background: [] }],
              [{ list: "bullet" }, { list: "ordered" }],
              ["clean"],
            ],
          }}
          formats={[
            "header", "font", "size",
            "bold", "italic", "underline",
            "color", "background",
            "list", "bullet",
          ]}
          style={{ height: "250px", marginBottom: "50px" }}
        />
      </Box>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenRichTextDialog(false)}>Cancel</Button>
    <Button
      variant="contained"
      color="success"
      startIcon={<CheckCircle />}
      onClick={handleSaveRichText}
      disabled={richTextLoading}
    >
      {richTextLoading ? "Saving..." : "Save"}
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default Target;